// Protocol Buffers for Demo Link Management & Consultation Services
// 
// Purpose: Admin-managed demo links with analytics and $500 consultation payments
// Wave 0: Foundation

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/demo/demo.proto (package guardianai.v1.demo, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/demo/demo.proto.
 */
export const file_guardianai_v1_demo_demo: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * ============================================
 * DEMO LINK MESSAGES
 * ============================================
 *
 * @generated from message guardianai.v1.demo.DemoLink
 */
export type DemoLink = Message<"guardianai.v1.demo.DemoLink"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * Admin-defined name (e.g., "Sarah's Daycare Demo")
   *
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * Optional notes
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * daycare, manuscript, eyeclinic, etc.
   *
   * @generated from field: string industry_key = 5;
   */
  industryKey: string;

  /**
   * Display name in demo UI
   *
   * @generated from field: string app_name = 6;
   */
  appName: string;

  /**
   * Hex color (e.g., "#1976d2")
   *
   * @generated from field: string brand_color = 7;
   */
  brandColor: string;

  /**
   * Optional logo URL
   *
   * @generated from field: string logo_url = 8;
   */
  logoUrl: string;

  /**
   * Complete shareable URL
   *
   * @generated from field: string full_url = 9;
   */
  fullUrl: string;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 13;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: string created_by_id = 14;
   */
  createdById: string;
};

/**
 * ============================================
 * DEMO LINK MESSAGES
 * ============================================
 *
 * @generated from message guardianai.v1.demo.DemoLink
 */
export type DemoLinkJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug?: string;

  /**
   * Admin-defined name (e.g., "Sarah's Daycare Demo")
   *
   * @generated from field: string label = 3;
   */
  label?: string;

  /**
   * Optional notes
   *
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * daycare, manuscript, eyeclinic, etc.
   *
   * @generated from field: string industry_key = 5;
   */
  industryKey?: string;

  /**
   * Display name in demo UI
   *
   * @generated from field: string app_name = 6;
   */
  appName?: string;

  /**
   * Hex color (e.g., "#1976d2")
   *
   * @generated from field: string brand_color = 7;
   */
  brandColor?: string;

  /**
   * Optional logo URL
   *
   * @generated from field: string logo_url = 8;
   */
  logoUrl?: string;

  /**
   * Complete shareable URL
   *
   * @generated from field: string full_url = 9;
   */
  fullUrl?: string;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 13;
   */
  expiresAt?: TimestampJson;

  /**
   * @generated from field: string created_by_id = 14;
   */
  createdById?: string;
};

/**
 * Describes the message guardianai.v1.demo.DemoLink.
 * Use `create(DemoLinkSchema)` to create a new message.
 */
export const DemoLinkSchema: GenMessage<DemoLink, {jsonType: DemoLinkJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 0);

/**
 * @generated from message guardianai.v1.demo.CreateDemoLinkRequest
 */
export type CreateDemoLinkRequest = Message<"guardianai.v1.demo.CreateDemoLinkRequest"> & {
  /**
   * Required
   *
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * Optional
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * Required
   *
   * @generated from field: string industry_key = 3;
   */
  industryKey: string;

  /**
   * Required
   *
   * @generated from field: string app_name = 4;
   */
  appName: string;

  /**
   * Default if not provided
   *
   * @generated from field: string brand_color = 5;
   */
  brandColor: string;

  /**
   * Optional
   *
   * @generated from field: string logo_url = 6;
   */
  logoUrl: string;

  /**
   * Optional (auto-generated if blank)
   *
   * @generated from field: string slug = 7;
   */
  slug: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 8;
   */
  expiresAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.demo.CreateDemoLinkRequest
 */
export type CreateDemoLinkRequestJson = {
  /**
   * Required
   *
   * @generated from field: string label = 1;
   */
  label?: string;

  /**
   * Optional
   *
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * Required
   *
   * @generated from field: string industry_key = 3;
   */
  industryKey?: string;

  /**
   * Required
   *
   * @generated from field: string app_name = 4;
   */
  appName?: string;

  /**
   * Default if not provided
   *
   * @generated from field: string brand_color = 5;
   */
  brandColor?: string;

  /**
   * Optional
   *
   * @generated from field: string logo_url = 6;
   */
  logoUrl?: string;

  /**
   * Optional (auto-generated if blank)
   *
   * @generated from field: string slug = 7;
   */
  slug?: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 8;
   */
  expiresAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.demo.CreateDemoLinkRequest.
 * Use `create(CreateDemoLinkRequestSchema)` to create a new message.
 */
export const CreateDemoLinkRequestSchema: GenMessage<CreateDemoLinkRequest, {jsonType: CreateDemoLinkRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 1);

/**
 * @generated from message guardianai.v1.demo.GetDemoLinkRequest
 */
export type GetDemoLinkRequest = Message<"guardianai.v1.demo.GetDemoLinkRequest"> & {
  /**
   * @generated from oneof guardianai.v1.demo.GetDemoLinkRequest.identifier
   */
  identifier: {
    /**
     * @generated from field: string id = 1;
     */
    value: string;
    case: "id";
  } | {
    /**
     * @generated from field: string slug = 2;
     */
    value: string;
    case: "slug";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message guardianai.v1.demo.GetDemoLinkRequest
 */
export type GetDemoLinkRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug?: string;
};

/**
 * Describes the message guardianai.v1.demo.GetDemoLinkRequest.
 * Use `create(GetDemoLinkRequestSchema)` to create a new message.
 */
export const GetDemoLinkRequestSchema: GenMessage<GetDemoLinkRequest, {jsonType: GetDemoLinkRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 2);

/**
 * @generated from message guardianai.v1.demo.UpdateDemoLinkRequest
 */
export type UpdateDemoLinkRequest = Message<"guardianai.v1.demo.UpdateDemoLinkRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string app_name = 4;
   */
  appName: string;

  /**
   * @generated from field: string brand_color = 5;
   */
  brandColor: string;

  /**
   * @generated from field: string logo_url = 6;
   */
  logoUrl: string;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 8;
   */
  expiresAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.demo.UpdateDemoLinkRequest
 */
export type UpdateDemoLinkRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string label = 2;
   */
  label?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: string app_name = 4;
   */
  appName?: string;

  /**
   * @generated from field: string brand_color = 5;
   */
  brandColor?: string;

  /**
   * @generated from field: string logo_url = 6;
   */
  logoUrl?: string;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 8;
   */
  expiresAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.demo.UpdateDemoLinkRequest.
 * Use `create(UpdateDemoLinkRequestSchema)` to create a new message.
 */
export const UpdateDemoLinkRequestSchema: GenMessage<UpdateDemoLinkRequest, {jsonType: UpdateDemoLinkRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 3);

/**
 * @generated from message guardianai.v1.demo.ListDemoLinksRequest
 */
export type ListDemoLinksRequest = Message<"guardianai.v1.demo.ListDemoLinksRequest"> & {
  /**
   * Optional filter
   *
   * @generated from field: string industry_filter = 1;
   */
  industryFilter: string;

  /**
   * Default true
   *
   * @generated from field: bool active_only = 2;
   */
  activeOnly: boolean;

  /**
   * Default 50
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;
};

/**
 * @generated from message guardianai.v1.demo.ListDemoLinksRequest
 */
export type ListDemoLinksRequestJson = {
  /**
   * Optional filter
   *
   * @generated from field: string industry_filter = 1;
   */
  industryFilter?: string;

  /**
   * Default true
   *
   * @generated from field: bool active_only = 2;
   */
  activeOnly?: boolean;

  /**
   * Default 50
   *
   * @generated from field: int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset?: number;
};

/**
 * Describes the message guardianai.v1.demo.ListDemoLinksRequest.
 * Use `create(ListDemoLinksRequestSchema)` to create a new message.
 */
export const ListDemoLinksRequestSchema: GenMessage<ListDemoLinksRequest, {jsonType: ListDemoLinksRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 4);

/**
 * @generated from message guardianai.v1.demo.ListDemoLinksResponse
 */
export type ListDemoLinksResponse = Message<"guardianai.v1.demo.ListDemoLinksResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.demo.DemoLink links = 1;
   */
  links: DemoLink[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.demo.ListDemoLinksResponse
 */
export type ListDemoLinksResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.demo.DemoLink links = 1;
   */
  links?: DemoLinkJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.demo.ListDemoLinksResponse.
 * Use `create(ListDemoLinksResponseSchema)` to create a new message.
 */
export const ListDemoLinksResponseSchema: GenMessage<ListDemoLinksResponse, {jsonType: ListDemoLinksResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 5);

/**
 * @generated from message guardianai.v1.demo.DeactivateLinkRequest
 */
export type DeactivateLinkRequest = Message<"guardianai.v1.demo.DeactivateLinkRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.demo.DeactivateLinkRequest
 */
export type DeactivateLinkRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.demo.DeactivateLinkRequest.
 * Use `create(DeactivateLinkRequestSchema)` to create a new message.
 */
export const DeactivateLinkRequestSchema: GenMessage<DeactivateLinkRequest, {jsonType: DeactivateLinkRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 6);

/**
 * ============================================
 * ANALYTICS MESSAGES
 * ============================================
 *
 * @generated from message guardianai.v1.demo.GetLinkAnalyticsRequest
 */
export type GetLinkAnalyticsRequest = Message<"guardianai.v1.demo.GetLinkAnalyticsRequest"> & {
  /**
   * @generated from field: string link_id = 1;
   */
  linkId: string;

  /**
   * Default 30
   *
   * @generated from field: int32 days = 2;
   */
  days: number;
};

/**
 * ============================================
 * ANALYTICS MESSAGES
 * ============================================
 *
 * @generated from message guardianai.v1.demo.GetLinkAnalyticsRequest
 */
export type GetLinkAnalyticsRequestJson = {
  /**
   * @generated from field: string link_id = 1;
   */
  linkId?: string;

  /**
   * Default 30
   *
   * @generated from field: int32 days = 2;
   */
  days?: number;
};

/**
 * Describes the message guardianai.v1.demo.GetLinkAnalyticsRequest.
 * Use `create(GetLinkAnalyticsRequestSchema)` to create a new message.
 */
export const GetLinkAnalyticsRequestSchema: GenMessage<GetLinkAnalyticsRequest, {jsonType: GetLinkAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 7);

/**
 * @generated from message guardianai.v1.demo.LinkAnalytics
 */
export type LinkAnalytics = Message<"guardianai.v1.demo.LinkAnalytics"> & {
  /**
   * @generated from field: string link_id = 1;
   */
  linkId: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * Core metrics
   *
   * @generated from field: int32 total_views = 4;
   */
  totalViews: number;

  /**
   * @generated from field: int32 unique_visitors = 5;
   */
  uniqueVisitors: number;

  /**
   * @generated from field: int32 onboarding_starts = 6;
   */
  onboardingStarts: number;

  /**
   * @generated from field: int32 onboarding_completes = 7;
   */
  onboardingCompletes: number;

  /**
   * @generated from field: int32 conversion_clicks = 8;
   */
  conversionClicks: number;

  /**
   * @generated from field: int32 payments_started = 9;
   */
  paymentsStarted: number;

  /**
   * @generated from field: int32 payments_completed = 10;
   */
  paymentsCompleted: number;

  /**
   * Calculated metrics
   *
   * onboarding_completes / onboarding_starts
   *
   * @generated from field: float completion_rate = 11;
   */
  completionRate: number;

  /**
   * conversion_clicks / onboarding_completes
   *
   * @generated from field: float conversion_rate = 12;
   */
  conversionRate: number;

  /**
   * @generated from field: float avg_session_seconds = 13;
   */
  avgSessionSeconds: number;

  /**
   * Time series
   *
   * @generated from field: repeated guardianai.v1.demo.DailyMetric daily_views = 14;
   */
  dailyViews: DailyMetric[];

  /**
   * Feature engagement
   *
   * @generated from field: repeated guardianai.v1.demo.FeatureEngagement feature_engagement = 15;
   */
  featureEngagement: FeatureEngagement[];
};

/**
 * @generated from message guardianai.v1.demo.LinkAnalytics
 */
export type LinkAnalyticsJson = {
  /**
   * @generated from field: string link_id = 1;
   */
  linkId?: string;

  /**
   * @generated from field: string label = 2;
   */
  label?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * Core metrics
   *
   * @generated from field: int32 total_views = 4;
   */
  totalViews?: number;

  /**
   * @generated from field: int32 unique_visitors = 5;
   */
  uniqueVisitors?: number;

  /**
   * @generated from field: int32 onboarding_starts = 6;
   */
  onboardingStarts?: number;

  /**
   * @generated from field: int32 onboarding_completes = 7;
   */
  onboardingCompletes?: number;

  /**
   * @generated from field: int32 conversion_clicks = 8;
   */
  conversionClicks?: number;

  /**
   * @generated from field: int32 payments_started = 9;
   */
  paymentsStarted?: number;

  /**
   * @generated from field: int32 payments_completed = 10;
   */
  paymentsCompleted?: number;

  /**
   * Calculated metrics
   *
   * onboarding_completes / onboarding_starts
   *
   * @generated from field: float completion_rate = 11;
   */
  completionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * conversion_clicks / onboarding_completes
   *
   * @generated from field: float conversion_rate = 12;
   */
  conversionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: float avg_session_seconds = 13;
   */
  avgSessionSeconds?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Time series
   *
   * @generated from field: repeated guardianai.v1.demo.DailyMetric daily_views = 14;
   */
  dailyViews?: DailyMetricJson[];

  /**
   * Feature engagement
   *
   * @generated from field: repeated guardianai.v1.demo.FeatureEngagement feature_engagement = 15;
   */
  featureEngagement?: FeatureEngagementJson[];
};

/**
 * Describes the message guardianai.v1.demo.LinkAnalytics.
 * Use `create(LinkAnalyticsSchema)` to create a new message.
 */
export const LinkAnalyticsSchema: GenMessage<LinkAnalytics, {jsonType: LinkAnalyticsJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 8);

/**
 * @generated from message guardianai.v1.demo.DailyMetric
 */
export type DailyMetric = Message<"guardianai.v1.demo.DailyMetric"> & {
  /**
   * YYYY-MM-DD
   *
   * @generated from field: string date = 1;
   */
  date: string;

  /**
   * @generated from field: int32 views = 2;
   */
  views: number;

  /**
   * @generated from field: int32 conversions = 3;
   */
  conversions: number;
};

/**
 * @generated from message guardianai.v1.demo.DailyMetric
 */
export type DailyMetricJson = {
  /**
   * YYYY-MM-DD
   *
   * @generated from field: string date = 1;
   */
  date?: string;

  /**
   * @generated from field: int32 views = 2;
   */
  views?: number;

  /**
   * @generated from field: int32 conversions = 3;
   */
  conversions?: number;
};

/**
 * Describes the message guardianai.v1.demo.DailyMetric.
 * Use `create(DailyMetricSchema)` to create a new message.
 */
export const DailyMetricSchema: GenMessage<DailyMetric, {jsonType: DailyMetricJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 9);

/**
 * @generated from message guardianai.v1.demo.FeatureEngagement
 */
export type FeatureEngagement = Message<"guardianai.v1.demo.FeatureEngagement"> & {
  /**
   * @generated from field: string feature_name = 1;
   */
  featureName: string;

  /**
   * @generated from field: int32 click_count = 2;
   */
  clickCount: number;

  /**
   * Percentage of visitors who clicked
   *
   * @generated from field: float engagement_rate = 3;
   */
  engagementRate: number;
};

/**
 * @generated from message guardianai.v1.demo.FeatureEngagement
 */
export type FeatureEngagementJson = {
  /**
   * @generated from field: string feature_name = 1;
   */
  featureName?: string;

  /**
   * @generated from field: int32 click_count = 2;
   */
  clickCount?: number;

  /**
   * Percentage of visitors who clicked
   *
   * @generated from field: float engagement_rate = 3;
   */
  engagementRate?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.demo.FeatureEngagement.
 * Use `create(FeatureEngagementSchema)` to create a new message.
 */
export const FeatureEngagementSchema: GenMessage<FeatureEngagement, {jsonType: FeatureEngagementJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 10);

/**
 * @generated from message guardianai.v1.demo.ExportLinkReportRequest
 */
export type ExportLinkReportRequest = Message<"guardianai.v1.demo.ExportLinkReportRequest"> & {
  /**
   * @generated from field: string link_id = 1;
   */
  linkId: string;

  /**
   * @generated from field: int32 days = 2;
   */
  days: number;
};

/**
 * @generated from message guardianai.v1.demo.ExportLinkReportRequest
 */
export type ExportLinkReportRequestJson = {
  /**
   * @generated from field: string link_id = 1;
   */
  linkId?: string;

  /**
   * @generated from field: int32 days = 2;
   */
  days?: number;
};

/**
 * Describes the message guardianai.v1.demo.ExportLinkReportRequest.
 * Use `create(ExportLinkReportRequestSchema)` to create a new message.
 */
export const ExportLinkReportRequestSchema: GenMessage<ExportLinkReportRequest, {jsonType: ExportLinkReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 11);

/**
 * @generated from message guardianai.v1.demo.LinkReportPdf
 */
export type LinkReportPdf = Message<"guardianai.v1.demo.LinkReportPdf"> & {
  /**
   * @generated from field: bytes pdf_data = 1;
   */
  pdfData: Uint8Array;

  /**
   * @generated from field: string filename = 2;
   */
  filename: string;
};

/**
 * @generated from message guardianai.v1.demo.LinkReportPdf
 */
export type LinkReportPdfJson = {
  /**
   * @generated from field: bytes pdf_data = 1;
   */
  pdfData?: string;

  /**
   * @generated from field: string filename = 2;
   */
  filename?: string;
};

/**
 * Describes the message guardianai.v1.demo.LinkReportPdf.
 * Use `create(LinkReportPdfSchema)` to create a new message.
 */
export const LinkReportPdfSchema: GenMessage<LinkReportPdf, {jsonType: LinkReportPdfJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 12);

/**
 * @generated from message guardianai.v1.demo.EmailReportRequest
 */
export type EmailReportRequest = Message<"guardianai.v1.demo.EmailReportRequest"> & {
  /**
   * @generated from field: string link_id = 1;
   */
  linkId: string;

  /**
   * @generated from field: string recipient_email = 2;
   */
  recipientEmail: string;

  /**
   * Optional
   *
   * @generated from field: string custom_message = 3;
   */
  customMessage: string;
};

/**
 * @generated from message guardianai.v1.demo.EmailReportRequest
 */
export type EmailReportRequestJson = {
  /**
   * @generated from field: string link_id = 1;
   */
  linkId?: string;

  /**
   * @generated from field: string recipient_email = 2;
   */
  recipientEmail?: string;

  /**
   * Optional
   *
   * @generated from field: string custom_message = 3;
   */
  customMessage?: string;
};

/**
 * Describes the message guardianai.v1.demo.EmailReportRequest.
 * Use `create(EmailReportRequestSchema)` to create a new message.
 */
export const EmailReportRequestSchema: GenMessage<EmailReportRequest, {jsonType: EmailReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 13);

/**
 * @generated from message guardianai.v1.demo.EmailReportResponse
 */
export type EmailReportResponse = Message<"guardianai.v1.demo.EmailReportResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.demo.EmailReportResponse
 */
export type EmailReportResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.demo.EmailReportResponse.
 * Use `create(EmailReportResponseSchema)` to create a new message.
 */
export const EmailReportResponseSchema: GenMessage<EmailReportResponse, {jsonType: EmailReportResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 14);

/**
 * ============================================
 * EVENT TRACKING MESSAGES
 * ============================================
 *
 * @generated from message guardianai.v1.demo.TrackDemoEventRequest
 */
export type TrackDemoEventRequest = Message<"guardianai.v1.demo.TrackDemoEventRequest"> & {
  /**
   * Which demo link
   *
   * @generated from field: string link_slug = 1;
   */
  linkSlug: string;

  /**
   * view, onboard_start, onboard_complete, feature_click, conversion_click
   *
   * @generated from field: string event_type = 2;
   */
  eventType: string;

  /**
   * Additional metadata
   *
   * @generated from field: map<string, string> event_data = 3;
   */
  eventData: { [key: string]: string };

  /**
   * Frontend-generated session ID
   *
   * @generated from field: string session_id = 4;
   */
  sessionId: string;
};

/**
 * ============================================
 * EVENT TRACKING MESSAGES
 * ============================================
 *
 * @generated from message guardianai.v1.demo.TrackDemoEventRequest
 */
export type TrackDemoEventRequestJson = {
  /**
   * Which demo link
   *
   * @generated from field: string link_slug = 1;
   */
  linkSlug?: string;

  /**
   * view, onboard_start, onboard_complete, feature_click, conversion_click
   *
   * @generated from field: string event_type = 2;
   */
  eventType?: string;

  /**
   * Additional metadata
   *
   * @generated from field: map<string, string> event_data = 3;
   */
  eventData?: { [key: string]: string };

  /**
   * Frontend-generated session ID
   *
   * @generated from field: string session_id = 4;
   */
  sessionId?: string;
};

/**
 * Describes the message guardianai.v1.demo.TrackDemoEventRequest.
 * Use `create(TrackDemoEventRequestSchema)` to create a new message.
 */
export const TrackDemoEventRequestSchema: GenMessage<TrackDemoEventRequest, {jsonType: TrackDemoEventRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 15);

/**
 * @generated from message guardianai.v1.demo.TrackDemoEventResponse
 */
export type TrackDemoEventResponse = Message<"guardianai.v1.demo.TrackDemoEventResponse"> & {
  /**
   * @generated from field: bool recorded = 1;
   */
  recorded: boolean;
};

/**
 * @generated from message guardianai.v1.demo.TrackDemoEventResponse
 */
export type TrackDemoEventResponseJson = {
  /**
   * @generated from field: bool recorded = 1;
   */
  recorded?: boolean;
};

/**
 * Describes the message guardianai.v1.demo.TrackDemoEventResponse.
 * Use `create(TrackDemoEventResponseSchema)` to create a new message.
 */
export const TrackDemoEventResponseSchema: GenMessage<TrackDemoEventResponse, {jsonType: TrackDemoEventResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 16);

/**
 * ============================================
 * DASHBOARD SUMMARY MESSAGES
 * ============================================
 *
 * @generated from message guardianai.v1.demo.GetDemoLinksSummaryRequest
 */
export type GetDemoLinksSummaryRequest = Message<"guardianai.v1.demo.GetDemoLinksSummaryRequest"> & {
};

/**
 * ============================================
 * DASHBOARD SUMMARY MESSAGES
 * ============================================
 *
 * @generated from message guardianai.v1.demo.GetDemoLinksSummaryRequest
 */
export type GetDemoLinksSummaryRequestJson = {
};

/**
 * Describes the message guardianai.v1.demo.GetDemoLinksSummaryRequest.
 * Use `create(GetDemoLinksSummaryRequestSchema)` to create a new message.
 */
export const GetDemoLinksSummaryRequestSchema: GenMessage<GetDemoLinksSummaryRequest, {jsonType: GetDemoLinksSummaryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 17);

/**
 * @generated from message guardianai.v1.demo.DemoLinksSummary
 */
export type DemoLinksSummary = Message<"guardianai.v1.demo.DemoLinksSummary"> & {
  /**
   * @generated from field: int32 total_active_links = 1;
   */
  totalActiveLinks: number;

  /**
   * @generated from field: int32 total_views_last_7_days = 2;
   */
  totalViewsLast7Days: number;

  /**
   * @generated from field: int32 total_conversions_last_7_days = 3;
   */
  totalConversionsLast7Days: number;

  /**
   * @generated from field: guardianai.v1.demo.DemoLinkPreview top_performer = 4;
   */
  topPerformer?: DemoLinkPreview;
};

/**
 * @generated from message guardianai.v1.demo.DemoLinksSummary
 */
export type DemoLinksSummaryJson = {
  /**
   * @generated from field: int32 total_active_links = 1;
   */
  totalActiveLinks?: number;

  /**
   * @generated from field: int32 total_views_last_7_days = 2;
   */
  totalViewsLast7Days?: number;

  /**
   * @generated from field: int32 total_conversions_last_7_days = 3;
   */
  totalConversionsLast7Days?: number;

  /**
   * @generated from field: guardianai.v1.demo.DemoLinkPreview top_performer = 4;
   */
  topPerformer?: DemoLinkPreviewJson;
};

/**
 * Describes the message guardianai.v1.demo.DemoLinksSummary.
 * Use `create(DemoLinksSummarySchema)` to create a new message.
 */
export const DemoLinksSummarySchema: GenMessage<DemoLinksSummary, {jsonType: DemoLinksSummaryJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 18);

/**
 * @generated from message guardianai.v1.demo.DemoLinkPreview
 */
export type DemoLinkPreview = Message<"guardianai.v1.demo.DemoLinkPreview"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: int32 views = 3;
   */
  views: number;

  /**
   * @generated from field: int32 conversions = 4;
   */
  conversions: number;
};

/**
 * @generated from message guardianai.v1.demo.DemoLinkPreview
 */
export type DemoLinkPreviewJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string label = 2;
   */
  label?: string;

  /**
   * @generated from field: int32 views = 3;
   */
  views?: number;

  /**
   * @generated from field: int32 conversions = 4;
   */
  conversions?: number;
};

/**
 * Describes the message guardianai.v1.demo.DemoLinkPreview.
 * Use `create(DemoLinkPreviewSchema)` to create a new message.
 */
export const DemoLinkPreviewSchema: GenMessage<DemoLinkPreview, {jsonType: DemoLinkPreviewJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 19);

/**
 * ============================================
 * CONSULTATION PAYMENT MESSAGES
 * ============================================
 *
 * @generated from message guardianai.v1.demo.CreateCheckoutRequest
 */
export type CreateCheckoutRequest = Message<"guardianai.v1.demo.CreateCheckoutRequest"> & {
  /**
   * Optional: which demo converted
   *
   * @generated from field: string demo_link_slug = 1;
   */
  demoLinkSlug: string;

  /**
   * @generated from field: string customer_email = 2;
   */
  customerEmail: string;

  /**
   * @generated from field: string customer_name = 3;
   */
  customerName: string;

  /**
   * Context from demo
   *
   * @generated from field: string industry_key = 4;
   */
  industryKey: string;
};

/**
 * ============================================
 * CONSULTATION PAYMENT MESSAGES
 * ============================================
 *
 * @generated from message guardianai.v1.demo.CreateCheckoutRequest
 */
export type CreateCheckoutRequestJson = {
  /**
   * Optional: which demo converted
   *
   * @generated from field: string demo_link_slug = 1;
   */
  demoLinkSlug?: string;

  /**
   * @generated from field: string customer_email = 2;
   */
  customerEmail?: string;

  /**
   * @generated from field: string customer_name = 3;
   */
  customerName?: string;

  /**
   * Context from demo
   *
   * @generated from field: string industry_key = 4;
   */
  industryKey?: string;
};

/**
 * Describes the message guardianai.v1.demo.CreateCheckoutRequest.
 * Use `create(CreateCheckoutRequestSchema)` to create a new message.
 */
export const CreateCheckoutRequestSchema: GenMessage<CreateCheckoutRequest, {jsonType: CreateCheckoutRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 20);

/**
 * @generated from message guardianai.v1.demo.CheckoutSession
 */
export type CheckoutSession = Message<"guardianai.v1.demo.CheckoutSession"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string checkout_url = 2;
   */
  checkoutUrl: string;

  /**
   * 50000 = $500
   *
   * @generated from field: int32 amount_cents = 3;
   */
  amountCents: number;

  /**
   * USD
   *
   * @generated from field: string currency = 4;
   */
  currency: string;
};

/**
 * @generated from message guardianai.v1.demo.CheckoutSession
 */
export type CheckoutSessionJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;

  /**
   * @generated from field: string checkout_url = 2;
   */
  checkoutUrl?: string;

  /**
   * 50000 = $500
   *
   * @generated from field: int32 amount_cents = 3;
   */
  amountCents?: number;

  /**
   * USD
   *
   * @generated from field: string currency = 4;
   */
  currency?: string;
};

/**
 * Describes the message guardianai.v1.demo.CheckoutSession.
 * Use `create(CheckoutSessionSchema)` to create a new message.
 */
export const CheckoutSessionSchema: GenMessage<CheckoutSession, {jsonType: CheckoutSessionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 21);

/**
 * @generated from message guardianai.v1.demo.StripeWebhookRequest
 */
export type StripeWebhookRequest = Message<"guardianai.v1.demo.StripeWebhookRequest"> & {
  /**
   * Raw Stripe webhook payload
   *
   * @generated from field: string payload = 1;
   */
  payload: string;

  /**
   * Stripe signature header
   *
   * @generated from field: string signature = 2;
   */
  signature: string;
};

/**
 * @generated from message guardianai.v1.demo.StripeWebhookRequest
 */
export type StripeWebhookRequestJson = {
  /**
   * Raw Stripe webhook payload
   *
   * @generated from field: string payload = 1;
   */
  payload?: string;

  /**
   * Stripe signature header
   *
   * @generated from field: string signature = 2;
   */
  signature?: string;
};

/**
 * Describes the message guardianai.v1.demo.StripeWebhookRequest.
 * Use `create(StripeWebhookRequestSchema)` to create a new message.
 */
export const StripeWebhookRequestSchema: GenMessage<StripeWebhookRequest, {jsonType: StripeWebhookRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 22);

/**
 * @generated from message guardianai.v1.demo.StripeWebhookResponse
 */
export type StripeWebhookResponse = Message<"guardianai.v1.demo.StripeWebhookResponse"> & {
  /**
   * @generated from field: bool processed = 1;
   */
  processed: boolean;

  /**
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * @generated from message guardianai.v1.demo.StripeWebhookResponse
 */
export type StripeWebhookResponseJson = {
  /**
   * @generated from field: bool processed = 1;
   */
  processed?: boolean;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;
};

/**
 * Describes the message guardianai.v1.demo.StripeWebhookResponse.
 * Use `create(StripeWebhookResponseSchema)` to create a new message.
 */
export const StripeWebhookResponseSchema: GenMessage<StripeWebhookResponse, {jsonType: StripeWebhookResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 23);

/**
 * @generated from message guardianai.v1.demo.ConsultationBooking
 */
export type ConsultationBooking = Message<"guardianai.v1.demo.ConsultationBooking"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string demo_link_id = 2;
   */
  demoLinkId: string;

  /**
   * @generated from field: string customer_email = 3;
   */
  customerEmail: string;

  /**
   * @generated from field: string customer_name = 4;
   */
  customerName: string;

  /**
   * @generated from field: string industry_key = 5;
   */
  industryKey: string;

  /**
   * @generated from field: string stripe_session_id = 6;
   */
  stripeSessionId: string;

  /**
   * @generated from field: string stripe_payment_intent_id = 7;
   */
  stripePaymentIntentId: string;

  /**
   * @generated from field: int32 amount_cents = 8;
   */
  amountCents: number;

  /**
   * @generated from field: string currency = 9;
   */
  currency: string;

  /**
   * pending, paid, calendar_booked, completed, refunded
   *
   * @generated from field: string status = 10;
   */
  status: string;

  /**
   * @generated from field: string calendar_link = 11;
   */
  calendarLink: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp paid_at = 13;
   */
  paidAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp booked_at = 14;
   */
  bookedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.demo.ConsultationBooking
 */
export type ConsultationBookingJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string demo_link_id = 2;
   */
  demoLinkId?: string;

  /**
   * @generated from field: string customer_email = 3;
   */
  customerEmail?: string;

  /**
   * @generated from field: string customer_name = 4;
   */
  customerName?: string;

  /**
   * @generated from field: string industry_key = 5;
   */
  industryKey?: string;

  /**
   * @generated from field: string stripe_session_id = 6;
   */
  stripeSessionId?: string;

  /**
   * @generated from field: string stripe_payment_intent_id = 7;
   */
  stripePaymentIntentId?: string;

  /**
   * @generated from field: int32 amount_cents = 8;
   */
  amountCents?: number;

  /**
   * @generated from field: string currency = 9;
   */
  currency?: string;

  /**
   * pending, paid, calendar_booked, completed, refunded
   *
   * @generated from field: string status = 10;
   */
  status?: string;

  /**
   * @generated from field: string calendar_link = 11;
   */
  calendarLink?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp paid_at = 13;
   */
  paidAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp booked_at = 14;
   */
  bookedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.demo.ConsultationBooking.
 * Use `create(ConsultationBookingSchema)` to create a new message.
 */
export const ConsultationBookingSchema: GenMessage<ConsultationBooking, {jsonType: ConsultationBookingJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 24);

/**
 * @generated from message guardianai.v1.demo.GetBookingRequest
 */
export type GetBookingRequest = Message<"guardianai.v1.demo.GetBookingRequest"> & {
  /**
   * @generated from oneof guardianai.v1.demo.GetBookingRequest.identifier
   */
  identifier: {
    /**
     * @generated from field: string id = 1;
     */
    value: string;
    case: "id";
  } | {
    /**
     * @generated from field: string stripe_session_id = 2;
     */
    value: string;
    case: "stripeSessionId";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message guardianai.v1.demo.GetBookingRequest
 */
export type GetBookingRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string stripe_session_id = 2;
   */
  stripeSessionId?: string;
};

/**
 * Describes the message guardianai.v1.demo.GetBookingRequest.
 * Use `create(GetBookingRequestSchema)` to create a new message.
 */
export const GetBookingRequestSchema: GenMessage<GetBookingRequest, {jsonType: GetBookingRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 25);

/**
 * @generated from message guardianai.v1.demo.ListBookingsRequest
 */
export type ListBookingsRequest = Message<"guardianai.v1.demo.ListBookingsRequest"> & {
  /**
   * @generated from field: string status_filter = 1;
   */
  statusFilter: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;
};

/**
 * @generated from message guardianai.v1.demo.ListBookingsRequest
 */
export type ListBookingsRequestJson = {
  /**
   * @generated from field: string status_filter = 1;
   */
  statusFilter?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset?: number;
};

/**
 * Describes the message guardianai.v1.demo.ListBookingsRequest.
 * Use `create(ListBookingsRequestSchema)` to create a new message.
 */
export const ListBookingsRequestSchema: GenMessage<ListBookingsRequest, {jsonType: ListBookingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 26);

/**
 * @generated from message guardianai.v1.demo.ListBookingsResponse
 */
export type ListBookingsResponse = Message<"guardianai.v1.demo.ListBookingsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.demo.ConsultationBooking bookings = 1;
   */
  bookings: ConsultationBooking[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.demo.ListBookingsResponse
 */
export type ListBookingsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.demo.ConsultationBooking bookings = 1;
   */
  bookings?: ConsultationBookingJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.demo.ListBookingsResponse.
 * Use `create(ListBookingsResponseSchema)` to create a new message.
 */
export const ListBookingsResponseSchema: GenMessage<ListBookingsResponse, {jsonType: ListBookingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 27);

/**
 * @generated from message guardianai.v1.demo.UpdateBookingStatusRequest
 */
export type UpdateBookingStatusRequest = Message<"guardianai.v1.demo.UpdateBookingStatusRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * Optional: set when calendar is booked
   *
   * @generated from field: string calendar_event_id = 3;
   */
  calendarEventId: string;
};

/**
 * @generated from message guardianai.v1.demo.UpdateBookingStatusRequest
 */
export type UpdateBookingStatusRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * Optional: set when calendar is booked
   *
   * @generated from field: string calendar_event_id = 3;
   */
  calendarEventId?: string;
};

/**
 * Describes the message guardianai.v1.demo.UpdateBookingStatusRequest.
 * Use `create(UpdateBookingStatusRequestSchema)` to create a new message.
 */
export const UpdateBookingStatusRequestSchema: GenMessage<UpdateBookingStatusRequest, {jsonType: UpdateBookingStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_demo_demo, 28);

/**
 * ============================================
 * DEMO ADMIN SERVICE
 * Manage shareable demo links from admin dashboard
 * ============================================
 *
 * @generated from service guardianai.v1.demo.DemoAdminService
 */
export const DemoAdminService: GenService<{
  /**
   * Link CRUD
   *
   * @generated from rpc guardianai.v1.demo.DemoAdminService.CreateDemoLink
   */
  createDemoLink: {
    methodKind: "unary";
    input: typeof CreateDemoLinkRequestSchema;
    output: typeof DemoLinkSchema;
  },
  /**
   * @generated from rpc guardianai.v1.demo.DemoAdminService.GetDemoLink
   */
  getDemoLink: {
    methodKind: "unary";
    input: typeof GetDemoLinkRequestSchema;
    output: typeof DemoLinkSchema;
  },
  /**
   * @generated from rpc guardianai.v1.demo.DemoAdminService.UpdateDemoLink
   */
  updateDemoLink: {
    methodKind: "unary";
    input: typeof UpdateDemoLinkRequestSchema;
    output: typeof DemoLinkSchema;
  },
  /**
   * @generated from rpc guardianai.v1.demo.DemoAdminService.ListDemoLinks
   */
  listDemoLinks: {
    methodKind: "unary";
    input: typeof ListDemoLinksRequestSchema;
    output: typeof ListDemoLinksResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.demo.DemoAdminService.DeactivateLink
   */
  deactivateLink: {
    methodKind: "unary";
    input: typeof DeactivateLinkRequestSchema;
    output: typeof DemoLinkSchema;
  },
  /**
   * Analytics
   *
   * @generated from rpc guardianai.v1.demo.DemoAdminService.GetLinkAnalytics
   */
  getLinkAnalytics: {
    methodKind: "unary";
    input: typeof GetLinkAnalyticsRequestSchema;
    output: typeof LinkAnalyticsSchema;
  },
  /**
   * @generated from rpc guardianai.v1.demo.DemoAdminService.ExportLinkReport
   */
  exportLinkReport: {
    methodKind: "unary";
    input: typeof ExportLinkReportRequestSchema;
    output: typeof LinkReportPdfSchema;
  },
  /**
   * @generated from rpc guardianai.v1.demo.DemoAdminService.EmailReportToSales
   */
  emailReportToSales: {
    methodKind: "unary";
    input: typeof EmailReportRequestSchema;
    output: typeof EmailReportResponseSchema;
  },
  /**
   * Event Tracking (called from frontend demo)
   *
   * @generated from rpc guardianai.v1.demo.DemoAdminService.TrackDemoEvent
   */
  trackDemoEvent: {
    methodKind: "unary";
    input: typeof TrackDemoEventRequestSchema;
    output: typeof TrackDemoEventResponseSchema;
  },
  /**
   * Dashboard summary for admin home
   *
   * @generated from rpc guardianai.v1.demo.DemoAdminService.GetDemoLinksSummary
   */
  getDemoLinksSummary: {
    methodKind: "unary";
    input: typeof GetDemoLinksSummaryRequestSchema;
    output: typeof DemoLinksSummarySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_demo_demo, 0);

/**
 * ============================================
 * CONSULTATION SERVICE
 * $500 Architecture Consultation Payments
 * ============================================
 *
 * @generated from service guardianai.v1.demo.ConsultationService
 */
export const ConsultationService: GenService<{
  /**
   * Stripe Checkout
   *
   * @generated from rpc guardianai.v1.demo.ConsultationService.CreateCheckoutSession
   */
  createCheckoutSession: {
    methodKind: "unary";
    input: typeof CreateCheckoutRequestSchema;
    output: typeof CheckoutSessionSchema;
  },
  /**
   * @generated from rpc guardianai.v1.demo.ConsultationService.HandleStripeWebhook
   */
  handleStripeWebhook: {
    methodKind: "unary";
    input: typeof StripeWebhookRequestSchema;
    output: typeof StripeWebhookResponseSchema;
  },
  /**
   * Booking Management
   *
   * @generated from rpc guardianai.v1.demo.ConsultationService.GetBooking
   */
  getBooking: {
    methodKind: "unary";
    input: typeof GetBookingRequestSchema;
    output: typeof ConsultationBookingSchema;
  },
  /**
   * @generated from rpc guardianai.v1.demo.ConsultationService.ListBookings
   */
  listBookings: {
    methodKind: "unary";
    input: typeof ListBookingsRequestSchema;
    output: typeof ListBookingsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.demo.ConsultationService.UpdateBookingStatus
   */
  updateBookingStatus: {
    methodKind: "unary";
    input: typeof UpdateBookingStatusRequestSchema;
    output: typeof ConsultationBookingSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_demo_demo, 1);

